import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useFirestoreQuery } from './hooks';
// Components
import Message from './Message';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { Button, List } from '@material-ui/core';
import { Send } from '@material-ui/icons';
import { firestore } from '../helpers/firebaseHelper';

const Channel = ({ user = null, onFocus }) => {
  const db = firestore;
  const { uid, displayName, photoURL, livestream } = user;
  const messagesRef = db.collection('messages');

  const messages = useFirestoreQuery(
    messagesRef.where("livestream", "==", livestream).orderBy('createdAt', 'desc').limit(100)
  );

  const [newMessage, setNewMessage] = useState('');

  const inputRef = useRef();
  const bottomListRef = useRef();

  const handleOnChange = e => {
    setNewMessage(e.target.value);
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const trimmedMessage = newMessage.trim();

    if (trimmedMessage) {

      // Add new message in Firestore
      messagesRef.add({
        text: trimmedMessage,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid,
        displayName,
        photoURL: photoURL || "",
        livestream
      });
      // Clear input field
      setNewMessage('');
      // Scroll down to the bottom of the list
      bottomListRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="overflow-auto h-full" style={{ maxHeight: 360 }}>
        <div className="max-w-screen-lg mx-auto">
          <List disablePadding>
            {
              messages
                ?.sort((first, second) =>
                  first?.createdAt?.seconds <= second?.createdAt?.seconds ? -1 : 1
                )
                ?.reverse().map(message => {
                  return <Message key={message.id} {...message} />
                })
            }
          </List>
          <div ref={bottomListRef} />
        </div>
      </div>
      <div className="my-2">
        <form
          onSubmit={handleOnSubmit}
          className="flex flex-row rounded-md px-4 py-3 z-10 max-w-screen-lg mx-auto border-1"
        >
          <input
            ref={inputRef}
            type="text"
            value={newMessage}
            onChange={handleOnChange}
            placeholder="Type your message here..."
            className="flex-1 bg-transparent outline-none"
            onFocus={() => {
              if (!user || !user.displayName) {
                onFocus();
              }
            }}
          />
          <Button
            size='small'
            disabled={!newMessage}
            variant="contained"
            startIcon={<Send />}
            color="secondary"
            type="submit"
          >
            Send
          </Button>
        </form>
      </div>
    </div>
  );
};

Channel.propTypes = {
  user: PropTypes.shape({
    uid: PropTypes.string,
    displayName: PropTypes.string,
    photoURL: PropTypes.string,
    livestream: PropTypes.string
  }),
};

export default Channel;
